import { CmStreamType } from '@svta/cml-cta'

/**
 * Common Media Client Data Stream Type
 *
 *
 * @enum
 *
 * @beta
 */
export const CmcdStreamType = CmStreamType as typeof CmStreamType

/**
 * @beta
 */
export type CmcdStreamType = CmStreamType;
